import {AmplitudeItemListName, getAmplitudeViewItemEventProperties, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";

export interface IGetAmplitudeOfferSelectItemEventPropertiesParams {
    offer: IAmplitudeViewItemOffer;
    index: number;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
}

export const getAmplitudeOfferSelectItemEventProperties = ({
    offer,
    index,
    itemListId,
    itemListName
}: IGetAmplitudeOfferSelectItemEventPropertiesParams): Record<string, string | string[] | number | null> => ({
    ...getAmplitudeViewItemEventProperties({
        offer,
        itemListId,
        itemListName
    }),
    property_id: null,
    index
});
import {AmplitudeItemListName, getAmplitudeViewItemEventProperties, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";

export interface IGetAmplitudeOfferSelectItemEventPropertiesParams {
    offer: IAmplitudeViewItemOffer;
    index: number;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
}

export const getAmplitudeOfferSelectItemEventProperties = ({
    offer,
    index,
    itemListId,
    itemListName
}: IGetAmplitudeOfferSelectItemEventPropertiesParams): Record<string, string | string[] | number | null> => ({
    ...getAmplitudeViewItemEventProperties({
        offer,
        itemListId,
        itemListName
    }),
    property_id: null,
    index
});
